import style from "@/styles/pages/ConfirmApplication/ConfirmApplication.module.css";
import { RootState } from "@/store/dtm";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useEffect } from "react";
import { setApplicationEndpointReached } from "@/slices/applicationSlice";
import FadeTransition from "@/styles/animation/FadeTransition";
import { useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import { ApplicationDto } from "@/lib/DTMWebAPIClient.generated";
import { setClickInsightEvents } from "@/lib/util";

export default function ConfirmApplication() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const application = useSelector(
    (state: RootState) => state.application.application
  );
  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );
  const legalTerms = useSelector(
    (state: RootState) => state.legalTerms
  );
  const credential = useSelector(
    (state: RootState) => state.credential
  );
  const referralProducts = useSelector((state: RootState) => state.referralProducts.products);
  const client = createApiClient({ timeout: 60000, token: credential.credential.accessToken });


  useEffect(() => {
    document.title = "Application Confirmation";
    setClickInsightEvents(referralProducts, undefined, undefined, undefined, undefined, application.id, applicant);

    if (application.applicationEndpointReached == false) {
      // set it to true, run script
      dispatch(setApplicationEndpointReached(true));
      setClickInsightEvents(referralProducts, "applicationSuccess", "successful");
    }

    let applicationCopy = {...application};
    client.apiApplicationsFetch().then((result) => {
      applicationCopy.applicationEndpointReached = true;
      result.application = applicationCopy;
      result.applicant = applicant;
      result.legalTerms = legalTerms;
      client.apiApplicationsSave(new ApplicationDto({
        applicationData: JSON.stringify(result)
      })).catch((error) => {
        console.log("Error saving application info", error);
      });
    }).catch((error) => {
      console.log("Error fetching application info", error);
    });

  }, []);

  const handleClick = () => {
    navigate('/home', {replace: true});
  }

  return (
    <FadeTransition>
      <main aria-labelledby="main-content">
        <div className="main-container max-md:mt-10">
          <div className={style.contentContainer}>
            <div className="flex flex-col max-xs:px-3 max-md:items-center">
              <div className={style.emHeading}>
                <div className="grid grid-cols-1">
                  <h1>Thank you for your application</h1>
                  <p>
                    One of our associates is currently reviewing your application and will be in touch shortly.
                  </p>
                  <p>
                    In the meantime, if you have any questions, give us a call at 1 (866) 592-2226 and one of our associates will assist you. 
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5">
            <button
              type="submit"
              onClick={handleClick}
              style={{width: 165}}
              className={clsx("primary mt-5 w-full sm:w-28 h-11 px-6")}>
              Go to Dashboard
            </button>
          </div>
        </div>
      </main>
    </FadeTransition>
  );
}
